import React, { useState, useEffect } from 'react';
import '../App.css';
import { useNavigate } from 'react-router-dom';
import { Button } from 'reactstrap';
import MyStorage from './util/storage'
import showToast from './util/toast'
import { Oval as Loader } from 'react-loader-spinner'
import { ToastContainer } from 'react-toastify';
import Api from './api/api'
import { getStorage, ref as storageRef, deleteObject } from 'firebase/storage'

const Lectures = () => {
  const navigate = useNavigate()
  const [models, setModels] = useState([])
  const [loader, setLoader] = useState(false)

  useEffect(() => {
    // login-check + load data
    if (!MyStorage.isLogin()) {
      console.log('not logged in');
      navigate('/login', { replace: true })
      return;
    }
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadData = () => {
    setLoader(true)
    Api.getLectures(
      (response) => {
        setLoader(false)
        // assume response is an array of lecture objects
        setModels(response || [])
      },
      (error) => {
        setLoader(false)
        console.error("Failed to fetch lectures:", error)
        showToast("Failed to load lectures")
      });
  };

  const editArticle = (item) => {
    navigate('/admin/add-lecture', { state: { model: item } })
  }

  const deleteArticle = async (item) => {
    if (!window.confirm('Are you sure you want to delete this chapter?')) return;

    // Optimistic UI update
    const original = [...models];
    const filtered = original.filter(m => m.id !== item.id);
    setModels(filtered);

    try {
      // If your Api.deleteLecture accepts a second param filePath (so backend can remove file from storage),
      // we pass item.filePath. If your API doesn't accept this, remove the second argument.
      if (item.filePath) {
        try {
          await deleteObject(storageRef(getStorage(), item.filePath));
        } catch (storageErr) {
          if (storageErr?.code !== 'storage/object-not-found') throw storageErr;
        }
      }
      await Api.deleteLecture(item.id);
      showToast("Chapter deleted successfully");
    } catch (err) {
      console.error("Failed to delete lecture:", err);
      showToast("Failed to delete Chapter");
      // restore
      setModels(original);
    }
  };

  return (
    <div className='main'>
      <ToastContainer />
      <div className='titlebar' style={{ backgroundColor: '#f2f2f2', padding: 10, margin: -15 }}>
        <div style={{ color: 'blue' }}>
          Chapters
        </div>
      </div>

      <div style={{ width: '100%', display: 'flex', flexDirection: 'column', padding: 0 }}>
        <div style={{ padding: 30, display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'auto' }}>
          <Button
            className='btn-block btn-dark'
            style={{ marginTop: 10, fontSize: 18, fontWeight: 'bold', backgroundColor: 'green', borderWidth: 0, height: 40, width: 300, alignSelf: 'center' }}
            onClick={() => navigate('/admin/add-lecture', { state: { model: null } })}
          >
            Add Chapter
          </Button>

          <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-start', justifyContent: 'center', gap: 12, marginTop: 12 }}>
            {models.length === 0 && !loader && (
              <div style={{ color: 'gray', marginTop: 20 }}>No chapter found.</div>
            )}

            {models.map((item, index) => {
              const key = item.id || index;
              return (
                <div
                  key={key}
                  style={{
                    width: '100%',
                    maxWidth: 920,
                    backgroundColor: 'white',
                    marginTop: 10,
                    padding: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
                    borderRadius: 6,
                    overflow: 'hidden'
                  }}
                >
                  <div style={{ display: 'flex', backgroundColor: '#fff', padding: 20, gap: 12 }}>


                    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, justifyContent: 'center' }}>
                      <div style={{ fontSize: 18, fontWeight: 600, marginBottom: 6 }}>{item.title}</div>

                      {/* <div style={{ color: '#444', marginBottom: 8 }}>{item.description}</div> */}

                      {/* {item.fileUrl && (
                        <div style={{ marginBottom: 8, display: 'flex', gap: 8, alignItems: 'center' }}>
                          <button
                            onClick={() => {
                              //item.fileUrl
                              navigate('/admin/view-lecture', { state: { model: item } })
                            }}
                            style={{ backgroundColor: 'gray', borderRadius:5, padding:5, paddingLeft:10, paddingRight:10, color:'white', border:'0px' }}>
                            View Chapter
                          </button>
                        </div>
                      )} */}

                      <div style={{ display: 'flex', gap: 8, marginTop: 6 }}>
                        <Button
                          className='btn-block btn-dark'
                          style={{ fontSize: 14, fontWeight: 'bold', backgroundColor: 'gray', borderWidth: 0, height: 36, paddingLeft:10, paddingRight:10,  }}
                          onClick={() => {
                            navigate('/admin/view-lecture', { state: { model: item } })
                          }}>
                          View Chapter
                        </Button>

                        <Button
                          className='btn-block btn-dark'
                          style={{ fontSize: 14, fontWeight: 'bold', backgroundColor: 'orange', borderWidth: 0, height: 36, width: 100 }}
                          onClick={() => editArticle(item)}>
                          Edit
                        </Button>

                        <Button
                          className='btn-block btn-dark'
                          style={{ fontSize: 14, fontWeight: 'bold', backgroundColor: 'red', borderWidth: 0, height: 36, width: 100 }}
                          onClick={() => deleteArticle(item)}>
                          Delete
                        </Button>
                      </div>
                    </div>
                  </div>

                </div>
              )
            })}
          </div>
        </div>
      </div>

      {
        loader &&
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999, background: 'rgba(0,0,0,0.2)' }}>
          <div style={{ padding: 10, backgroundColor: 'red', borderRadius: 100 }}>
            <Loader
              type="ThreeDots"
              color="white"
              height={70}
              width={70}
              visible={true} />
          </div>
        </div>
      }
    </div >
  )
}

export default Lectures
